module.exports = __webpack_public_path__ + "img/aluminum.be5030ca.webp";